/* ─────────────────────────────────────────────────────────────
   Plain-decimal check for a `money` value (ENT-565 FR-67). Text in, message out: the value is never
   parsed to a number, rounded or formatted. Kept apart from the renderer component so the check can
   be shared by the resolver's rule, the list builder and the wizard.
   ───────────────────────────────────────────────────────────── */

/** Digits, with at most two decimals: `1500`, `1500.5`, `1500.50`. No sign, no thousands separator. */
export const PLAIN_DECIMAL = /^[0-9]+(\.[0-9]{1,2})?$/;

export const MONEY_FORMAT_MESSAGE =
  'Enter an amount in digits with at most two decimals, for example 1500 or 1500.50.';

/** The message for a value that is not a plain decimal; `undefined` for an empty value or a good one. */
export function moneyFormatError(value: unknown): string | undefined {
  const text = typeof value === 'string' ? value.trim() : value == null ? '' : String(value);
  if (text === '') return undefined;
  return PLAIN_DECIMAL.test(text) ? undefined : MONEY_FORMAT_MESSAGE;
}
